<!-- 8/10/20 jcc -- asset detail form using primary agency language if user account is associated with it. -->
<div *ngIf="activeAsset" id="detailview" style="height:100%" cdkDrag cdkDragBoundary="#cardViewDiv" class="avPanel pr-0" >
  <app-configurable-header
    cdkDragHandle
    [headingText]="asstDtlTitle"
    [variant]="'none'"
    (actionOne)="minimizeAssetDetail()"
    [tooltipOne]="isShown == false ? expand : minimize"
    [iconOne]="isShown == false ? 'arrow-down' : 'arrow-up'"
    [tooltipTwo]="'Close'"
    [iconTwo]="'cross'"
    (actionTwo)="closeAssetDetail()"
  >
  </app-configurable-header>

  <!-- 89.5 for double panel -->
  <div class="avDetailPanel overflow-hidden" id="avDetailPanelDiv" (mousedown)="$event.stopPropagation()">
    <mat-tab-group disablePagination="true" style="height:100%">
 
      <!-- Details tab -->
      <mat-tab class="asset-detail" style="height:100%" [attr.aria-label]="'Select.carddisplay.detailtab' | translate" [label]="'Select.carddisplay.detailtab' | translate">
        <div style="height:100%; overflow:clip;">   <!-- added overflow: clip to remove extra scroll bar that appeared after ng17 upgrade.-->
          <div *ngIf="activeAsset" style="height:100%" class="col-12 border-0 p-0 tab-content text-center">
            <div class="tab-pane p-0 border-top active" style="height:100%">
              <div class="card border-0" style="height:100%">

                <!-- regular inventory assets -->
                <div *ngIf="!isVisualizationAsset" class="scroll-detail">

                  <!-- detail header -->
                  <div class="asset-detail-header">
                    <div style="display: flex" class="img-fields-container">
                      <div class="img-container">
                        <img
                          class="text-center justify-content-center align-self-center"
                          alt="{{ activeAsset[0]['AssetCode'] }}"
                          [src]="activeAsset[2]?.ImageBase64 != null ? activeAsset[2]?.ImageBase64 : activeAsset[7]?.ImageBase64"
                          (error)="onPicError($event)"
                        />
                      </div>
                      <div class="key-columns">
                        <span class="h7" *ngIf="fieldsInfo.length > 0 && fieldsInfo[0].codedValues">{{ activeAsset[0]["AssetCode"] }}</span>
                        <span class="h7" *ngIf="fieldsInfo.length > 0 && !fieldsInfo[0].codedValues">{{ activeAsset[0]["AssetCode"] }}</span>
                        <span class="avFormLabel">{{ activeAsset[0]["AssetID"] }}</span>
                      </div>
                    </div>
                    <div class="lidar" (click)="loadLidarData()" *ngIf="currentUser.clientId === 509">
                      <a href="#" title="View Lidar Data" aria-label="View Lidar Data" class="i-inactive" data-mainPageTabbing="yes">
                        <mat-icon style="color:#323237;" Zclass="icon-new icon-new-select">radar</mat-icon>
                      </a>
                    </div>
                  </div>

                  <!-- detail fields -->
                  <div *ngIf="fieldsInfo && defaultDisabledFields && defaultDisabledFields.length > 0">

                    <!-- loop field defs and present on form with appropriate control -->
                    <div *ngFor="let agencyList of fieldsInfo" class="w-100" [hidden]="onlyMakeSignFields && !makeSignFieldList.includes(agencyList.fieldName)"> <!-- 2026 added onlyMakeSignFields logic to react to checkbox on MakeView form-->

                      <!-- Asset Code combo selector -- child asset -->
                      <div *ngIf="agencyList.type == 'esriFieldTypeString' && agencyList.fieldName == 'AssetCode' && assetCodeFrmAssetSubType.length != 0 " 
                        class="w-100 special-dropdown"
                      >
                        <sms-autocomplete
                          label="Asset Code"
                          [(value)]="activeAsset[0][agencyList.fieldName]"
                          [selectDataObjects]="assetCodeFrmAssetSubType"
                          [required]="true"
                          valueField="code"
                          descriptionField="name"
                          (valueChange)="getAssetDefaultValues($event)"
                          [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                        >
                        </sms-autocomplete>
                      </div>

                      <!-- Asset Code combo selector -- parent asset -->
                      <div *ngIf="agencyList.fieldName == 'AssetCode' && assetCodeFrmAssetSubType.length == 0" class="w-100 special-dropdown">
                        <sms-autocomplete
                          label="Asset Code"
                          [(value)]="activeAsset[0][agencyList.fieldName]"
                          [selectDataObjects]="agencyList.codedValues"
                          [required]="true"
                          valueField="code"
                          descriptionField="name"
                          display="both"
                          (valueChange)="getAssetDefaultValues($event)"
                          [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                        >
                        </sms-autocomplete>
                      </div>

                      <!-- AssetSubType start-->
                      <div
                        *ngIf="agencyList.type == 'esriFieldTypeString' && agencyList.fieldName == 'AssetSubType' && assetCodeFrmAssetSubType.length > 0">
                        <mat-form-field [ngClass]="{
                            'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0
                          }" appearance="outline">
                          <mat-label [attr.aria-label]="agencyList.label">
                            <span [ngClass]="{
                                'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0
                              }">{{ currentUser.scndLang ? agencyList.labelSL : agencyList.label }}<span
                                *ngIf="agencyList.IsRequired == 1">★</span></span>
                          </mat-label>
                          <mat-select [ngClass]="{
                              'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0
                            }" 
                            [(ngModel)]="activeAsset[0][agencyList.fieldName]" 
                            #assetSubType="ngModel"
                            (selectionChange)="objSubTypeChanged()"
                            [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                          >
                            <mat-option [value]="item.id" *ngFor="let item of agencyList.codedValues">
                              <span>{{ item.name }}</span>
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="assetSubType.hasError('required')"> This field is required </mat-error>
                        </mat-form-field>
                      </div>
                      <!-- AssetSubType end -->

                      <!-- inputs -->
                      <mat-form-field 
                        [ngClass]="{'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0 }"
                        *ngIf="agencyList.type && agencyList.fieldName != 'AssetCode' && agencyList.fieldName != 'AssetSubType'"
                        appearance="outline"
                      >
                        <mat-label [attr.aria-label]="agencyList.label">
                          <span [ngClass]="{'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0 }">
                            {{ currentUser.scndLang ? agencyList.labelSL : agencyList.label }}<span *ngIf="agencyList.IsRequired == 1">★</span>
                          </span>
                        </mat-label>

                        <!-- text entry-->
                        <input
                          *ngIf="agencyList.fieldName != 'AssetCode' && (!agencyList.codedValues || agencyList.codedValues.length === 0) && agencyList.type != 'esriFieldTypeDate'"
                          matInput
                          [ngClass]="{'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0}"
                          #inputText="ngModel"
                          [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                          [type]="getInputType(agencyList.fieldName, agencyList.type)"
                          [(ngModel)]="activeAsset[0][agencyList.fieldName]"
                          (change)="changeValue($event, agencyList.fieldName, agencyList.IsRequired)"
                        />

                        <!-- date -->
                        <input
                          *ngIf="agencyList.fieldName != 'AssetCode' && (!agencyList.codedValues || agencyList.codedValues.length === 0) && agencyList.type == 'esriFieldTypeDate'"
                          matInput
                          [ngClass]="{'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0}"
                          #inputText="ngModel"
                          [matDatepicker]="picker"
                          (dateChange)="changeTime($event, agencyList.fieldName)"
                          placeholder="Date Time"
                          [ngModel]="activeAsset[0][agencyList.fieldName] | customDatePipe"
                          name="agencyList.fieldName"
                          [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                          autocomplete="off"
                          (change)="changeValue($event, agencyList.fieldName, agencyList.IsRequired)"
                        />
                        <mat-datepicker-toggle
                          [ngStyle]="{ display: agencyList.fieldName != 'AssetCode' 
                                    && (!agencyList.codedValues || agencyList.codedValues.length === 0) 
                                    && agencyList.type == 'esriFieldTypeDate' ? 'initial' : 'none'}"
                          matSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker />

			                  <!-- domain value picker -->
                        <div *ngIf="agencyList.codedValues && agencyList.codedValues.length > 0 && agencyList.fieldName != 'AssetSubType' && agencyList.fieldName != 'AssetCode' 
                          && agencyList.fieldName != 'DoNotReplace'">
                          <mat-select
                            [ngClass]="{'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0}"
                            #dropdown="ngModel"
                            [(ngModel)]="activeAsset[0][agencyList.fieldName]"
                            [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                            (selectionChange)="changeValue($event, agencyList.fieldName, agencyList.IsRequired)"
                          >
                            <mat-option [value]="item.code ?? item.name" *ngFor="let item of agencyList.codedValues">
                              <span>{{ item.name }}</span>
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="dropdown.hasError('required')"> This field is required </mat-error>
                       </div>

                        <!-- Do Not Replace -->
                        <div *ngIf="agencyList.codedValues && agencyList.codedValues.length > 0 && agencyList.fieldName != 'AssetSubType' && agencyList.fieldName != 'AssetCode' && agencyList.fieldName == 'DoNotReplace'">
                          <mat-select [disabled]="doNotReplaceDisable(agencyList.fieldName)"
                            [ngClass]="{'empty-required': agencyList.IsRequired == 1 && (activeAsset[0][agencyList.fieldName] == null || activeAsset[0][agencyList.fieldName] == '') && activeAsset[0][agencyList.fieldName] != 0}"
                            #dropdown="ngModel"
                            [(ngModel)]="activeAsset[0][agencyList.fieldName]"
                            [disabled]="(!isDataEditor) || findFieldisDisable(agencyList.fieldName)"
                            (selectionChange)="changeValue($event, agencyList.fieldName, agencyList.IsRequired)"
                          >
                            <mat-option [value]="item.code ?? item.name" *ngFor="let item of agencyList.codedValues">
                              <span>{{ item.name }}</span>
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="dropdown.hasError('required')"> This field is required </mat-error>
                        </div>

                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- visualization asset details -->
                <div *ngIf="isVisualizationAsset" class="scroll-detailVis avDetailScrollArea">
                  <div>
                    <div *ngFor="let data of currentLayerData" class="row">
                      <div style="text-align: left; padding-right: 0px" class="col-12">
                        <label style="display: block" class="avFormLabel">
                          {{ data.Label }}
                        </label>
                      </div>
                      <div class="col-12 mb-2">
                        <input class="avDetailFormControl" disabled="true" style="background-color: #f3f5fd !important" type="text" value="{{ data.Value }}" />
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- details tab footer -->
                <div class="sms-form-footer">
                  <!-- photo viewer / manage images -->
                  <button
                    title="Manage Images for Asset"
                    class="i-inactive"
                    type="button"
                    [ngStyle]="{ visibility: isAssetNew || eeService.addNewChild ? 'hidden' : 'visible' }"
                    [disabled]="isVisualizationAsset"
                    mat-button
                    class="primary-button"
                    (click)="viewImage(content)"
                    *ngIf="!isVisualizationAsset"
                  >
                    Manage Images
                  </button>

                  <!-- save -->
                  <button 
                    title="Save Changes" 
                    type="button" 
                    mat-button 
                    class="primary-button" 
                    (click)="saveAsset()"
                    *ngIf="isDataEditor"
                  > 
                   Save
                  </button>

                  <!-- delete -->
                  <button
                    class="i-inactive"
                    type="button"
                    mat-stroked-button
                    title="Delete"
                    class="inverse-button"
                    (click)="deleteAsset()"
                    [disabled]="isVisualizationAsset"
                    [class.disabled-contenct]="dataEditorSettings?.hardDelete == 1 ? false : true"
                    *ngIf="currentUser.rolePermissions.assetDeleteRecord && !ismodelpopup && isDataEditor"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tasks tab-->
      <mat-tab style="height:100%; overflow:none" *ngIf="!isVisualizationAsset && !this.eeService.addNewParent && !this.eeService.addNewChild" [attr.aria-label]="'Select.carddisplay.tasktab' | translate" [label]="'Select.carddisplay.tasktab' | translate">
        <sms-tasks
          [Graphic]="Graphic"
          [Point]="Point"
          [FeatureLayer]="FeatureLayer"
          [asset]="activeAsset"
          [activeAsset]="activeAsset"
          [Query]="Query"
          [QueryTask]="QueryTask"
          [webMercatorUtils]="webMercatorUtils"
          [geometryJsonUtils]="geometryJsonUtils"
          [map]="map"
          (closeCard)="closeCardViewForRetire()"
        ></sms-tasks>
      </mat-tab>

      <!-- Assessment tab -->
      <mat-tab style="height:100%" [attr.aria-label]="'Select.carddisplay.assessmenttab' | translate" *ngIf="!isVisualizationAsset && !this.eeService.addNewParent && !this.eeService.addNewChild" [label]="'Select.carddisplay.assessmenttab' | translate">
        <sms-Assessment [activeAsset]="activeAsset" [webMercatorUtils]="webMercatorUtils"></sms-Assessment>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- document viewer -->
  <ng-template #content let-modal let-d="dismiss">
    <app-configurable-header 
      [headingText]="'Select.photoviewer.header' | translate" 
      [variant]="'none'" 
      [iconOne]="'cross'" 
      [tooltipOne]="'Close'" 
      (actionOne)="d('Cross click')"
    /> 

    <div class="modal-body sms-model-imageviewer" style="transform: none; touch-action: none;">

      <div class="sort-container" style="padding-bottom:5px;" title="Sort images">
        <button class="small pv-btn" id="Date" data-toggle="collapse" *ngIf="currentUser.soultionTiers[0][0].sort_Documents" (click)="OrderImages('Date')">
          {{ "Select.docassessment.datefilter" | translate }}
          <ng-container>
            <mat-icon title="Sort Descending" *ngIf="!showDateByOrder; else ElseBlock" aria-hidden="true" svgIcon="arrow-up"></mat-icon>
            <ng-template #ElseBlock>
              <mat-icon title="Sort Ascending" aria-hidden="true" svgIcon="arrow-down"></mat-icon>
            </ng-template>
          </ng-container>
        </button>
        <button class="small pv-btn" id="Sequence" *ngIf="linearAssetValues && currentUser.soultionTiers[0][0].sort_Documents" data-toggle="collapse" (click)="OrderImages('Measure')">
          {{ "Select.docassessment.sequencefilter" | translate }}
          <ng-container>
            <mat-icon title="Sort Descending" *ngIf="!showSequenceByOrder; else ElseBlock" aria-hidden="true" svgIcon="arrow-up"></mat-icon>
            <ng-template #ElseBlock>
              <mat-icon title="Sort Ascending" svgIcon="arrow-down"></mat-icon>
            </ng-template>
          </ng-container>
        </button>
        <button class="small pv-btn" id="Source" *ngIf="currentUser.soultionTiers[0][0].sort_Documents" data-toggle="collapse" (click)="OrderImages('SourceTag')">
          {{ "Select.docassessment.sourcefilter" | translate }}
          <ng-container>
            <mat-icon title="Sort Descending" *ngIf="!showSourceByOrder; else ElseBlock" aria-hidden="true" svgIcon="arrow-up"></mat-icon>
            <ng-template #ElseBlock>
              <mat-icon title="Sort Ascending" aria-hidden="true" svgIcon="arrow-down"></mat-icon>
            </ng-template>
          </ng-container>
        </button>
      </div>

      <nav>
        <mat-button-toggle-group class="button-group" #group="matButtonToggleGroup" [value]="imageSrc" (change)="EventChange($event)">
          <mat-button-toggle *ngFor="let sample of samples; let i = index" color="primary" [value]="sample.url" style="color: white;"> {{ sample.Date | date: 'mediumDate'}}</mat-button-toggle>
        </mat-button-toggle-group>
      </nav>

      <div style="display:flex; height:89%; justify-content:center;">
        <app-photo-zoom
          *ngIf="imageSrc !== '' && !imageSrc.includes('application/pdf')"
          style="height:100%;"
          [fullImage]="imageSrc"
        />
      </div>
      <!--<img *ngIf="imageSrc !== '' && !imageSrc.includes('application/pdf')" imageSrc [src]="imageSrc" style="width: 80%" />  -->

      <ng-container *ngIf="imageSrc.includes('application/pdf')"><pdf-viewer [src]="imageSrc" [render-text]="true" [original-size]="false" style="height: 500px"></pdf-viewer></ng-container>
      <input type="file" accept=".jpg, .jpeg, .pdf" #assetPhotoUpload class="d-none" (change)="uploadNew(assetPhotoUpload.files)" aria-label="select file" />
    </div>

    <div class="photo-data">
      <div class="xsmall photo-date">{{ "Select.docassessment.photodate" | translate }} : {{ PhotoDate | date : "medium" }}</div>
      <div class="xsmall photo-date">{{ "Select.docassessment.sourceandcondition" | translate }} : {{ SourceTag }}</div>
      <div class="xsmall photo-date" *ngIf="linearAssetValues">{{ "Select.docassessment.measureinterval" | translate }}: {{ MeasureValue }}</div>
    </div>

    <!-- footer -->
    <div class="modal-footer">
      <div class="justify-content-end">

        <!-- upload -->
        <button
          title=""
          mat-button
          *ngIf="currentUser.rolePermissions.documentAdd && isDataEditor"
          type="button"
          class="primary-button"
          style="margin-left:8px;"
          (click)="assetPhotoUpload.click()"
        >
          {{ "Select.photoviewer.uploadbtn" | translate }}
        </button>

        <!-- export -->
        <button title="" 
          mat-button 
          type="button" 
          class="primary-button" 
          style="margin-left:8px;"
          (click)="export()"
        >
          {{ "Select.photoviewer.exportbtn" | translate }}
        </button>

        <!-- delete -->
        <button
          title=""
          mat-stroked-button
          *ngIf="currentUser.rolePermissions.documentRemove && isDataEditor"
          type="button"
          class="inverse-button"
          style="margin-left:8px;"
          (click)="deleteImage()"
        >
          {{ "Select.photoviewer.deletebtn" | translate }}
        </button>
      </div>
    </div>
  </ng-template>  <!-- end of document viewer modal -->

</div>